import baseUrl from "../config/baseUrl";

const updateEmailTemplateData = async ({
  token,
  userId,
  id,
  name,
  description,
  type,
  language,
  subject,
  body_html,
  status
}) => {
  const formData = new FormData();
  formData.append("userId", userId);
  formData.append("id", id);
  if (name !== undefined) formData.append("name", name);
  if (description !== undefined) formData.append("description", description);
  if (type !== undefined) formData.append("type", type);
  if (language !== undefined) formData.append("language", language);
  if (subject !== undefined) formData.append("subject", subject);
  if (body_html !== undefined) formData.append("body_html", body_html);
  if (status !== undefined) formData.append("status", status);

  // Use PUT or POST with _method=PUT depending on how Laravel is configured
  formData.append("_method", "PUT");

  try {
    const response = await fetch(`${baseUrl}/api/update-email-template-data`, {
      method: "POST", // using POST with _method=PUT is safer with FormData
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default updateEmailTemplateData;
